var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar"},[_c('div',{staticClass:"span"},[_vm._v(_vm._s(_vm.title))]),(_vm.isShow)?_c('div',{staticClass:"more",on:{"click":_vm.goTo}},[_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticStyle:{"min-width":"26.6px"}},[_vm._v("更多")]),_c('img',{attrs:{"src":require("@/assets/img/Right.png"),"alt":"#"}})])
}]

export { render, staticRenderFns }